import React, { useState, useRef, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Button from '../../components/elements/button';
import { Mail, Security } from '../../assets/icons';
import { authApi } from '../../network/apis/auth';
import { toast } from 'react-toastify';

const MailVerification = () => {
    const location = useLocation();
    const email = location.state?.email || 'your email';
    const navigate = useNavigate();
    const [verificationCode, setVerificationCode] = useState(['', '', '', '', '', '']);
    const inputRefs = useRef([]);

    useEffect(() => {
        // Focus first input on mount
        if (inputRefs.current[0]) {
            inputRefs.current[0].focus();
        }
    }, []);

    const handleCodeChange = (index, value) => {
        if (isNaN(value)) return;

        const newCode = [...verificationCode];
        newCode[index] = value;
        setVerificationCode(newCode);

        // Auto-focus next input
        if (value !== '' && index < 5) {
            inputRefs.current[index + 1].focus();
        }
    };

    const handleKeyDown = (index, e) => {
        // Handle backspace
        if (e.key === 'Backspace' && !verificationCode[index] && index > 0) {
            inputRefs.current[index - 1].focus();
        }
    };

    const handleVerifyCode = async () => {
        const code = verificationCode.join('');
        if (code.length !== 6) {
            alert('Please enter all digits');
            return;
        }

        try {
            await authApi.verifyEmail(email, code);
            toast.success('Email verified successfully!');
            navigate('/verify-success');
        } catch (error) {
            console.error('Verification failed:', error);
            alert('Invalid verification code');
        }
    };

    const handleResendCode = async () => {
        try {
            
            await authApi.resendCode(email);
            toast.success('Verification code resent successfully!');
            setVerificationCode(['', '', '', '', '', '']);
        } catch (error) {
            console.error('Error resending code:', error);
            alert('Failed to resend verification code');
        }
    };

    return (
        <div className="auth-container">
            <div className="verification-content">
                <div className="auth-logo-section">
                                                E-AQUAHEALTH
                                                <img src={Security} alt="security"/>
                                            </div>
                <img src={Mail} alt="Email Verification" className="verify-icon" />
                <h1>Verify your email</h1>
                <p>We've sent a verification code to <strong>{email}</strong></p>
                <p>Enter the 6-digit code below</p>

                <div className="verification-code-inputs">
                    {verificationCode.map((digit, index) => (
                        <input
                            key={index}
                            ref={el => inputRefs.current[index] = el}
                            type="text"
                            maxLength="1"
                            value={digit}
                            onChange={e => handleCodeChange(index, e.target.value)}
                            onKeyDown={e => handleKeyDown(index, e)}
                            className="code-input"
                        />
                    ))}
                </div>
                
                <div className="verification-actions">
                    <Button 
                        text="Verify Code" 
                        onClick={handleVerifyCode}
                        type="button"
                        fullWidth
                    />
                    <div className="resend-section">
                        <p>Didn't receive the code?</p>
                        <button 
                            className="resend-button"
                            onClick={handleResendCode}
                        >
                            Resend Code
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MailVerification;